import { useState } from 'react';
import { Lock } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';

const AccessGate = ({ onAccessGranted }) => {
  const { t } = useTranslation();
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [isShaking, setIsShaking] = useState(false);
  
  const CORRECT_CODE = 'VASIROD2026';

  const handleSubmit = (e) => {
    e.preventDefault();
    if (code.toUpperCase() === CORRECT_CODE) {
      sessionStorage.setItem('accessGranted', 'true');
      onAccessGranted();
    } else {
      setError('Invalid access code. Please try again.');
      setIsShaking(true);
      setTimeout(() => setIsShaking(false), 500);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-stone-50 to-stone-100 flex items-center justify-center p-4">
      {/* Language Switcher in top-right corner */}
      <div className="absolute top-4 right-4">
        <LanguageSwitcher />
      </div>
      
      <div className={`bg-white border border-stone-200 rounded-sm shadow-lg p-8 md:p-12 w-full max-w-md transform transition-all duration-300 ${isShaking ? 'animate-shake' : ''}`}>
        <div className="flex justify-center mb-8">
          <div className="w-16 h-16 border border-stone-300 rounded-full flex items-center justify-center">
            <Lock className="w-8 h-8 text-stone-600" />
          </div>
        </div>
        
        <div className="text-center mb-8">
          <h1 className="text-3xl md:text-4xl font-noto-serif font-light text-stone-800 mb-2 tracking-wide">
            {t('bridegroomNames')}

          </h1>
          <div className="w-16 h-px bg-stone-300 mx-auto mb-6"></div>
          <p className="text-stone-600 font-tenor font-light tracking-wide">
            {t('accessGateSubtitle')}
          </p>
        </div>
        
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <input
              type="text"
              value={code}
              onChange={(e) => {
                setCode(e.target.value);
                setError('');
              }}
              placeholder={t('accessCodePlaceholder')}
              className="w-full px-0 py-4 bg-transparent border-0 border-b border-stone-300 text-stone-800 placeholder-stone-400 focus:outline-none focus:border-stone-800 transition-colors duration-300 text-center text-lg font-tenor font-light tracking-widest uppercase"
              autoFocus
            />
          </div>
          
          {error && (
            <div className="bg-red-50 border-l-4 border-red-400 p-4">
              <p className="text-red-700 font-tenor font-light text-sm">{t('accessCodeInvalid')}</p>
            </div>
          )}
          
          <button
            type="submit"
            className="w-full bg-stone-800 text-white font-tenor font-light py-4 px-6 tracking-widest hover:bg-stone-700 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-stone-500 focus:ring-offset-2"
          >
            {t('accessGateButton')}
          </button>
        </form>

        <div className="mt-8 text-center">
          <p className="text-stone-500 font-tenor font-light text-xs tracking-wide">
            {t('privateAccessNote')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default AccessGate;